import { createModuleHttpClient } from '../../createModuleHttpClient';
import jobModule from '../index';

const client = createModuleHttpClient(jobModule.id);

/**
 * Dispatch a webhook call through the server relay so the webhook URL
 * and token never leave the server.
 */
export async function callWebhook(data: Record<string, unknown>) {
  return client.callWebhook('rescheduleWebhook', data);
}

export default client;
